/** The film-level analytics "tier" = its target length bucket (the price driver). Plain module: usable from RSC and client. */
export function filmTier(targetSeconds: number | null | undefined): string {
  return targetSeconds && targetSeconds > 0 ? `${targetSeconds}s` : 'unknown';
}
